<template>
  <detail-layout-two-columns :toEdge="false">
    <template slot="LeftCol">
      <base-header
        style="padding-left: 0px"
        icon="user"
        :content="header"
      />
        <notification-new-metadata-dialog 
          :dialogOpen="showNewMetadato" 
          :notification="this.notificationId" 
          :idCliente="this.form.idCliente"
          @toggleDialog="toggleDialogMetadato" 
          @applyDialog="applyDialogMetadatoHandler"
        />
        <notification-update-metadata-dialog 
          :dialogOpen="showUpdateMetadato" 
          :campo="this.selectedUpdateMetadataCampo" 
          :valorDefecto="this.selectedUpdateMetadataValor" 
          :metadataId="this.selectedUpdateMetadataId" 
          @toggleDialog="toggleDialogUpdateMetadato" 
          @applyDialog="applyDialogUpdateMetadatoHandler" 
          :idCliente="this.form.idCliente"/>
        <notification-new-document-dialog 
          :dialogOpen="showNewDocument" 
          :notification="this.notificationId" 
          :values="tiposDocumentosAeat"
          :showTipoDocumento="isFromAEAT && hasModulePresentacionesAEAT"
          @toggleDialog="toggleDialogs" 
          @applyDialog="applyDialogHandler"/>
        <div class="form-wrapper">
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
          >
            <div  class="hideHScroll">
              <ul class="list-none p-0 m-0 flex flex-col lg:flex-row lg:flex-wrap -mx-2">
                <li class="px-2 w-full mb-4" v-if="form.NeoAMano">
                  <base-ro-input :label="$t('app.neo_manual')"/>
                </li>
                <li class="px-2 w-full mb-4" v-if="form.DescargadaAutomaticamente">
                  <base-ro-input :label="$t('app.neo_descarga_automatica')"/>
                </li>

                <li class="px-2 w-full mb-2 lg:mb-4" v-if="role === 'SuperAdministrador' && form.Distribuidor">
                  <base-ro-input :label="$t('distributors.distributor')" :data="form.Distribuidor"/>
                </li>
                <li class="px-2 w-full mb-2 lg:mb-4" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
                  <div class="flex justify-between items-end">
                    <base-ro-input :label="$t('app.client')" :data="form.Empresa" class="w-full"/>
                    <base-button class="mb-1 ml-4 mr-2" 
                      mode="primary" 
                      :text="$t('app.detail')" 
                      @click.prevent.stop="goDetailClient" 
                      :loading="isGeneralLoading"
                      />
                  </div>
                </li>

                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4" v-if="!this.showEditMode">
                  <base-ro-input :label="$t('app.CIFTitular')" :data="form.CIFTitular"/>
                </li>
                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4" v-if="!this.showEditMode">
                  <base-ro-input :label="$t('companies.companyName')" :data="form.NombreEmpresa"/>
                </li>

                <li class="px-2 w-full mb-2 lg:mb-4" v-if="this.showEditMode">
                  <AccessibleElSelect
                    v-model="form.company"
                    prop="company"
                    :options="companiesForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="isGeneralLoading"
                    id-prefix="notification"
                  >
                    <template slot="label"><base-obligatory-icon/>{{$t('configurations.company')}}</template>
                  </AccessibleElSelect>
                </li>

                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4" v-if="this.showEditMode">
                  <AccessibleElSelect
                    v-model="form.OrganismoSelect"
                    prop="OrganismoSelect"
                    :options="organismosForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="isGeneralLoading"
                    :remote="true"
                    :remoteMethod="remoteOrganismos"
                    popperClass="wrap-select-popover"
                    :loading="loadingOrganismos"
                    id-prefix="notification"
                  >
                    <template slot="label">
                      <div class="flex items-center gap-x-2">
                        <base-obligatory-icon/>{{$t('notificationFilter.agency')}}
                        <base-tooltip-icon size="sm" :section="$t('notificationFilter.agency')" :content="'Escribe para iniciar la búsqueda'"/>
                      </div>
                    </template>
                  </AccessibleElSelect>
                </li>
                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4" v-if="!this.showEditMode">
                  <base-ro-input :label="$t('notificationFilter.agency')" :data="form.Organismo"/>
                </li>

                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4">
                  <base-ro-input :label="$t('notificationFilter.location')" :data="form.Sede"/>
                </li>

                <li class="px-2 w-full mb-2 lg:mb-4" v-if="!this.showEditMode">
                  <base-ro-input :label="$t('notificationFilter.subject')" :data="form.Asunto"/>
                </li>
                <li class="px-2 w-full mb-2 lg:mb-4" v-if="this.showEditMode">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('notificationFilter.subject')}}
                    <el-form-item prop="Asunto">
                      <el-input
                        :disabled="isGeneralLoading"
                        class="w-full"
                        type="text"
                        v-model="form.Asunto"
                        maxlength='500'
                      />
                    </el-form-item>
                  </label>
                </li>

                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4" v-if="!this.showEditMode">
                  <base-ro-input :label="$t('notificationFilter.disposition_date')" :data="form.FechaDisposicion"/>
                </li>
                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4" v-if="!this.showEditMode">
                  <base-ro-input :label="$t('app.date_download')" :data="form.FechaDescarga"/>
                </li>

                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4 flex items-center" v-if="this.showEditMode">
                  <div class="block">
                    <span id="notification-fecha-disposicion-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('notificationFilter.disposition_date')}}</span>
                    <el-form-item prop="FechaDisposicionDateTime">
                      <el-date-picker
                        :clearable="false"
                        :disabled="isGeneralLoading"
                        class="bg-white dark:bg-darkblue-900"
                        v-model="form.FechaDisposicionDateTime"
                        type="datetime"
                        format="dd-MM-yyyy HH:mm"
                        placeholder="dd-MM-aaaa HH:mm:ss"
                        :picker-options="dateRangeOptions"
                        aria-labelledby="notification-fecha-disposicion-label"
                        ref="datePickerFechaDisposicion"
                        @blur="onBlurDatePickerFechaDisposicion"
                        @focus="onFocusDatePickerFechaDisposicion"
                        @keydown.native="captureKeyNotChrome"
                        popper-class="datePickerFechaDisposicion-popover"
                        >
                      </el-date-picker>
                    </el-form-item>
                  </div>
                  <base-clear-input-button
                    v-if="form.FechaDisposicionDateTime"
                    aria-label="Limpiar fecha de disposición"
                    @clear="form.FechaDisposicionDateTime = null"
                  />
                </li>
                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4 flex items-center" v-if="this.showEditMode">
                  <div class="block">
                    <span id="notification-fecha-descarga-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.date_download')}}</span>
                    <el-form-item prop="FechaDescargaDateTime">
                      <el-date-picker
                        :clearable="false"
                        :disabled="isGeneralLoading"
                        class="bg-white dark:bg-darkblue-900"
                        v-model="form.FechaDescargaDateTime"
                        type="datetime"
                        format="dd-MM-yyyy HH:mm"
                        placeholder="dd-MM-aaaa HH:mm"
                        :picker-options="dateRangeOptions"
                        aria-labelledby="notification-fecha-descarga-label"
                        ref="datePickerFechaDescarga"
                        @blur="onBlurDatePickerFechaDescarga"
                        @focus="onFocusDatePickerFechaDescarga"
                        @keydown.native="captureKeyNotChrome"
                        popper-class="datePickerFechaDescarga-popover"
                        >
                      </el-date-picker>
                    </el-form-item>
                  </div>
                  <base-clear-input-button
                    v-if="form.FechaDescargaDateTime"
                    aria-label="Limpiar fecha de descarga"
                    @clear="form.FechaDescargaDateTime = null"
                  />
                </li>

                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4">
                  <base-ro-input-wrap :label="$t('app.TicketID')" :data="form.TicketID"/>
                </li>
                <li class="px-2 w-full lg:w-1/2 mb-2 lg:mb-4">
                  <base-ro-input :label="$t('notificationFilter.status')" :data="form.Estado"/>
                </li>

                <li class="px-2 w-full mb-2 lg:mb-4" v-if="isErrorState && form.UltimoError">
                  <base-ro-input :label="$t('notificationFilter.lastError')" :data="form.UltimoError"/>
                </li>
              </ul>
              <div class="lg:mb-4 flex items-center">
                <div class="block">
                  <span id="notification-fecha-fin-tramite-label" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.end_date')}}</span>
                  <el-form-item prop="fechaFinTramite">
                    <el-date-picker  
                      :clearable="false"
                      class="bg-white dark:bg-darkblue-900"
                      v-model="form.fechaFinTramite"
                      :picker-options="dateRangeOptions"
                      type="date"
                      format="dd-MM-yyyy"
                      placeholder="dd-mm-aaaa"
                      :disabled="role === 'UsuarioConsulta' || !form.EsPropietario"
                      aria-labelledby="notification-fecha-fin-tramite-label"
                      ref="datePickerFinTramite"
                      @blur="onBlurDatePickerFinTramite"
                      @focus="onFocusDatePickerFinTramite"
                      @keydown.native="captureKeyNotChrome"
                      popper-class="datePickerFinTramite-popover"
                      >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <base-clear-input-button
                  v-if="form.fechaFinTramite"
                  aria-label="Limpiar fecha de fin de trámite"
                  @clear="form.fechaFinTramite = null"
                />
              </div>
              
              <div class="lg:mb-4" v-if="hasModuleOrgProvinces">
                <AccessibleElSelect
                  v-model="form.OrganismoProvincia"
                  prop="OrganismoProvincia"
                  :options="organismosProvForAccessibleSelect"
                  :withFormItem="true"
                  :isDisabled="loadingOrganismos"
                  :remote="true"
                  :remoteMethod="remoteOrganismosProv"
                  popperClass="wrap-select-popover"
                  :loading="loadingOrganismos"
                  id-prefix="notification"
                >
                  <template slot="label">
                    <div class="flex items-center gap-x-2">
                      <base-obligatory-icon/>{{$t('organismoprovincia.title')}}
                      <base-tooltip-icon size="sm" :section="$t('organismoprovincia.title')" :content="'Escribe para iniciar la búsqueda'"/>
                    </div>
                  </template>
                </AccessibleElSelect>
              </div>

              <div class="mt-8 lg:mb-4">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Metadatos adicionales</h2>
                <base-accessible-table
                  ref="metadatos"
                  :rows="form.Metadatos"
                  :columns="metadatosColumns"
                  rowKey="Campo"
                  :theadClass="form.Metadatos && form.Metadatos.length > 0 ? '' : 'sr-only'"
                >
                  <template #cell-Campo="{ row }">
                    <span :title="row.Campo">{{ row.Campo }}</span>
                  </template>
                  <template #cell-Valor="{ row }">
                    <span :title="row.Valor">{{ row.Valor }}</span>
                  </template>
                  <template #cell-actions="{ row }">
                    <div class="flex flex-row">
                      <base-button-icon
                        v-if="role !== 'UsuarioConsulta' && form.EsPropietario"
                        @click="editMetadatoAdicional(row)"
                        name="editpencil"
                        mode="core"
                        size="xs"
                        ariaLabel="Editar metadato"
                      />
                      <base-button-icon
                        v-if="role !== 'UsuarioConsulta' && form.EsPropietario"
                        @click="deleteMetadatoAdicional(row)"
                        name="trash"
                        mode="core"
                        size="xs"
                        ariaLabel="Eliminar metadato"
                      />
                    </div>
                  </template>
                </base-accessible-table>
              </div>
              <div class="w-full m-2 float-right">
                  <base-button-responsive
                    v-if="role !== 'UsuarioConsulta' && form.EsPropietario"
                    mode="primary"
                    :text="$t('notificationFilter.new_metadata')"
                    @click="newMetadato()"
                    icon="plus"
                    class="m-5 float-right"
                  />
              </div>
              <table-element-adjuntos
                :Adjuntos="form.Adjuntos"
                @showAdjunto="showAdjunto"
                @downloadAdjunto="downloadAdjunto"
                />
              <table-element-doc-relacionados
                :DocumentosRelacionados="form.DocumentosRelacionados"
                :hasModulePresentacionesAEAT="hasModulePresentacionesAEAT"
                :isFromAEAT="isFromAEAT"
                :EsPropietario="form.EsPropietario"
                :role="role"
                @showAdjunto="showAdjunto"
                @downloadAdjunto="downloadAdjunto"
                @toggleEditTipoDocumento="toggleEditTipoDocumento"
                @deleteDocumentoRelacionado="deleteDocumentoRelacionado"
                />
              <div class="w-full m-2 mb-[6rem]">
                  <base-button-responsive
                    v-if="role !== 'UsuarioConsulta' && form.EsPropietario"
                    mode="primary"
                    :text="$t('notificationFilter.new_document')"
                    @click="newDocument()"
                    icon="plus"
                    class="m-5 float-right"
                  />
              </div>
              <div class="pb-2" v-if="form.MotivoRechazo">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.MotivoRechazo')}}
                    <el-form-item prop="MotivoRechazo">
                      <el-input
                        disabled
                        type="textarea"
                        :rows="3"
                        class="w-full"
                        :aria-label="$t('notificationFilter.MotivoRechazo')"
                        v-model="form.MotivoRechazo"
                        maxlength="1000"
                      />
                    </el-form-item>
                  </label>
              </div>

              <div v-if="form.TieneReglaAplicada" class="rounded-md bg-secondary-50 p-1 dark:text-darkblue-400 dark:bg-darkblue-900 mb-8" >
                <div v-if="form.idUltimaReglaAplicada" class="flex space-between items-end m-2">
                  <div class="w-full">
                    <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold">Última regla aplicada</h2>
                    <div  class="px-2 w-full mt-2">
                      <base-ro-input :label="$t('certificates.name')" :data="form.UltimaReglaAplicada"/>
                    </div>
                  </div>
                  <base-button 
                    v-if="!isRoleUserOrConsulta"
                    class="mb-1" 
                    mode="primary" 
                    :text="$t('app.detail')" 
                    @click.prevent.stop="goDetailRule" 
                    :loading="isGeneralLoading"/>
                </div>
                <div v-else class="flex space-between items-center m-2">
                  <h2 class="w-full font-bold">Última regla aplicada eliminada</h2>
                </div>
              </div>

              <div v-if="form.TieneDiligencias" class="rounded-md bg-secondary-50 p-1 dark:text-darkblue-400 dark:bg-darkblue-900 mb-8" >
                <div class="flex space-between items-end m-2">
                  <div class="w-full">
                    <div  class="px-2 w-full mt-2">
                      <base-ro-input :label="$t('procedings.title')" :data="$t('procedings.has_neo')"/>
                    </div>
                  </div>
                  <base-button 
                    v-if="role !== 'UsuarioConsulta' && role !== 'Usuario'"
                    class="mb-1" 
                    mode="primary" 
                    :text="$t('app.detail')" 
                    @click.prevent.stop="goToDiligencias" 
                    :loading="isGeneralLoading"/>
                </div>
              </div>

              <div class="mb-8">
                <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-200 block mb-3">Grupos vinculados</label>
                <groups-tags :Grupos="form.Grupos"/>
              </div> 

              <!-- <div class="mb-8" v-if="form.GrupoPropietarioAnterior && form.GrupoPropietarioAnterior.length > 0"> -->
              <div class="mb-8" v-if="false">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Grupo propietario anterior</h2>
                <groups-tags :Grupos="form.GrupoPropietarioAnterior"/>
              </div> 
              <div class="mb-8" v-if="form.GrupoPropietarioAnteriorNombre">
                <base-ro-input :label="'Grupo propietario anterior'" :data="form.GrupoPropietarioAnteriorNombre"/>
              </div>
              <div class="mb-8" v-if="form.UsuarioResponsable">
                <base-ro-input :label="$t('app.user_responsable')" :data="form.UsuarioResponsable.Usuario"/>
              </div>

              <div class="pb-4">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.full_text')}}
                    <el-form-item prop="full_text">
                      <el-input
                        :disabled="role === 'UsuarioConsulta' || !form.EsPropietario"
                        type="textarea"
                        :rows="3"
                        class="w-full"
                        :aria-label="$t('notificationFilter.full_text')"
                        v-model="form.full_text"
                        maxlength="1000"
                      />
                    </el-form-item>
                  </label>
              </div>

              <div class="pb-4">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('notificationFilter.resumen')}}
                    <el-form-item prop="resumen" class="mb-0">
                      <el-input
                        :disabled="role === 'UsuarioConsulta' || !form.EsPropietario"
                        type="textarea"
                        :rows="5"
                        class="w-full"
                        :aria-label="$t('notificationFilter.resumen')"
                        v-model="form.resumen"
                        maxlength="1000"
                      />
                    </el-form-item>
                  </label>
              </div>

              <div class="w-full mb-2" v-if="hasModuleAsistenciaIA && form.EstadoSugerencia">
                <base-ro-input-minimal :label="$t('app.status_suggested')" :data="form.EstadoSugerencia"/>
              </div>

              <div class="w-full mb-2 lg:mb-4" v-if="hasModuleAsistenciaIA && form.GrupoSugerido">
                <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-200 block mb-3">{{ $t('app.groups_suggested') }}</label>
                <groups-tags :Grupos="[form.GrupoSugerido]"/>
              </div> 

              <div class="w-full mb-2 lg:mb-4" v-if="hasModuleAsistenciaIA && form.FechaFinTramiteSugerida">
                <base-ro-input :label="$t('app.date_end_suggested')" :data="form.FechaFinTramiteSugerida"/>
              </div>

            </div>
          </el-form>
        </div>
    </template>
    <template slot="RightCol">
      <div 
        ref="pdfContainer"
        :class="{ 'h-screen': showPdf }" 
        class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full"
        >
          <PDFViewerApp
            v-show="showPdf"
            :search="actualFilterContent"
            @pdfViewerOpenHandler="pdfViewerOpenHandler"
            :pdf="url"
            :container-width="pdfContainerWidth"/>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />

          <base-table-select-actions-form 
            ref="baseTableSelectActionsFormAPIRequests"
            v-if="hasModuleAPIRequests && peticionesAPIAccionesFilter && peticionesAPIAccionesFilter.length > 0"
            :baseDropDownVisible="peticionesAPIAccionesFilter && peticionesAPIAccionesFilter.length > 0"
            :name="peticionAPIName"
            >
            <template slot="more">
              <span v-for="action in peticionesAPIAccionesFilter" :key="action.idPeticion">
                <base-button-item-list theme="dark" @click="showActionModalPetition(action)" :disabled="isGeneralLoading" :loading="isGeneralLoading">
                  <base-icon name="send" class="mr-2" :ariaHidden="true"/>
                  <div class="w-72 text-left">
                    {{ action.NombreAccion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>
          <input-select-org-province-dialog 
            :header="$t('organismoprovincia.add')"
            :headerValue="$t('organismoprovincia.title')"
            :dialogOpen="showModalOrgProvince" 
            @toggleDialog="toggleModalOrgProvince" 
            @applyDialog="sendUpdateOrgProvinceAndPetitionAPI"
            :idCliente="this.form.idCliente"
            />

          <base-table-select-actions-form 
            ref="baseTableSelectActionsFormNotificationActions"
            v-if="notificationActions && notificationActions.length > 0"
            :baseDropDownVisible="notificationActions.length > 0">
            <template slot="more">
              <span v-for="action in notificationActions" :key="action.IdAccion">
                <base-button-item-list theme="dark" @click="showActionModal(action)" :disabled="isGeneralLoading" :loading="isGeneralLoading">
                  <base-icon :name="selectActionIcon(action)" class="mr-2" :ariaHidden="true"/>
                  <div class="w-72 text-left">
                    {{ action.Descripcion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>
          <base-button-responsive
            v-if="showButtonEditMode"
            mode="primary"
            :text="$t('configurations.change_mode_template_edit')"
            @click="toggleEditMode()"
            icon="editpencil"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
           <base-button-responsive
            v-if="canUseCopyClipboard"
            mode="primary"
            :text="$t('app.copy_link_download')"
            @click="copyLinkDownload()"
            icon="copyurl"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="role !== 'UsuarioConsulta' && form.EsPropietario"
            mode="primary"
            :text="$t('app.save')"
            @click="submitForm('ruleForm')"
            icon="save"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
        <BaseElDialog
          :title="$t('app.user_responsable_unlink')"
          :visible.sync="showModalUnlinkUserResponsable"
          @open="handleOpenModalDialog('container-handleOpenModal-unlink-user-responsable')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkUserResponsable }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink-user-responsable">
              <base-button class="w-full" @click="showModalUnlinkUserResponsable = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkUserResponsableHandler(); showModalUnlinkUserResponsable = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          :title="$t('app.user_responsable_reasign')"
          :visible.sync="showUserResponsable"
          @open="handleOpenModalDialog([
            'container-handleOpenModal-userresponsable-prop-body',
            'container-handleOpenModal-userresponsable-prop',
            ])"
          :close-on-click-modal="!isSelectDropdownOpen"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
            <div 
              ref="container-handleOpenModal-userresponsable-prop-body"
              >
              <el-form
                ref="ruleForm"
              >
                <div>
                  <AccessibleElSelect
                    v-model="userResponsableSelected"
                    prop="userResponsableSelected"
                    :options="usersForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="isLoadingSelect"
                    id-prefix="notifications"
                    @visible-change="onExpand"
                    @change="onChangeInput"
                  >
                    <template #label>
                        {{$t('configurations.username')}}
                    </template>
                  </AccessibleElSelect>
                </div>
              </el-form>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-userresponsable-prop">
              <base-button class="w-full" @click="showUserResponsable = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"
                />
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyUserResponsableReasignHandler()}"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"
                />
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Borrar notificación"
          :visible.sync="showModalDelete"
          @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
              <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {submitAction(); showModalDelete = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Aplicar reglas de reparto"
          :visible.sync="showModalApplyRules"
          @open="handleOpenModalDialog('container-handleOpenModal-apply-rules-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageApplyRules }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-apply-rules-neo">
              <base-button class="w-full" @click="showModalApplyRules = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyRulesManualHandler(); showModalApplyRules = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Aplicar reglas de reparto"
          :visible.sync="showModalApplyRulesEmail"
          @open="handleOpenModalDialog('container-handleOpenModal-apply-rules-email')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageApplyRulesEmail }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-apply-rules-email">
              <base-button class="w-full" @click="showModalApplyRulesEmail = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyRulesManualEmailHandler(); showModalApplyRulesEmail = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Pasar notificación a tramitada"
          :visible.sync="showModalTramitar"
          @open="handleOpenModalDialog('container-handleOpenModal-tramitar-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageTramitar }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-tramitar-neo">
              <base-button class="w-full" @click="showModalTramitar = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {tramitarHandler(); showModalTramitar = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
            title="Archivar sin descargar"
            :visible.sync="showModalArchivar"
            @open="handleOpenModalDialog('container-handleOpenModal-archivar-neo')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageArchivar }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-archivar-neo">
                <base-button class="w-full" @click="showModalArchivar = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {submitAction(); showModalArchivar = false}"/>
              </div>
            </template>
        </BaseElDialog>
        <BaseElDialog
          title="Descargar notificación"
          :visible.sync="showModal"
          @open="handleOpenModalDialog('container-handleOpenModal-download-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-download-neo">
              <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {submitAction(); showModal = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Reasignar propietario"
          :visible.sync="showModalLinkGroupsReasig"
          @open="handleOpenModalDialog([
            'container-handleOpenModal-reasign-prop-body',
            'container-handleOpenModal-reasign-prop',
            ])"
          :close-on-click-modal="!isSelectDropdownOpen"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
            <div 
              ref="container-handleOpenModal-reasign-prop-body"
              >
              <el-form
                ref="ruleForm"
              >
                <div class="lg:mb-2">
                    <AccessibleElSelect
                      v-model="groupReasignSelected"
                      prop="groupReasignSelected"
                      :options="groupsForAccessibleSelect"
                      :withFormItem="true"
                      :group="true"
                      id-prefix="notification"
                    >
                      <template slot="label">{{$t('app.groups')}}</template>
                    </AccessibleElSelect>
                  
                    <label for="switch-mantener-grupo" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('configurations.reasign_owner_option')}}
                    </label>
                    <el-switch 
                      id="switch-mantener-grupo"
                      :aria-label="$t('configurations.reasign_owner_option')"
                      class="switch-text break-normal mt-2" 
                      v-model="mantenerGrupo" 
                      :active-text="$t('app.active')">
                    </el-switch>
                </div>
              </el-form>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-reasign-prop">
              <base-button class="w-full" @click="showModalLinkGroupsReasig = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"
                />
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkReasignHandler(); showModalLinkGroupsReasig = false}"
                />
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
            title="Vincular grupos"
            :visible.sync="showModalLinkGroups"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-vinc-groups-body',
              'container-handleOpenModal-vinc-groups',
              ])"
            :close-on-click-modal="!isSelectDropdownOpen"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
              <div 
                class="overflow-x-hidden"
                ref="container-handleOpenModal-vinc-groups-body"
                :style="{'height':heightContainerSelect}"
                >
                <el-form
                  ref="ruleForm"
                >
                  <div class="">
                    <div>
                      <AccessibleElSelect
                        v-model="listaGroupsSelected"
                        prop="listaGroupsSelected"
                        :options="groupsForAccessibleSelect"
                        :withFormItem="true"
                        :group="true"
                        :isMultiple="true"
                        :isDisabled="isLoadingSelect"
                        id-prefix="notification"
                        @visible-change="onExpand"
                        @change="onChangeInput"
                      >
                        <template slot="label">{{$t('app.groups')}}</template>
                      </AccessibleElSelect>
                    </div>
                    <span v-if="processMessageVincularRepartoActive" v-html="processMessageVincularReparto" class="w-full dark:text-darkblue-200 inline-block word-break-n"/>
                  </div>
                </el-form>
              </div>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-vinc-groups">
                <base-button class="w-full" v-if="isAllSelected" @click="handleUnSelectAll" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="isLoadingSelect" :loading="isLoadingSelect"/>
                <base-button class="w-full" v-if="!isAllSelected" :disabled="isLoadingSelect || isEmptyList" @click="handleSelectAll" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelect"/>
                <div class="w-48"></div>
                <base-button class="w-full" @click="showModalLinkGroups = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"
                  :loading="isLoadingSelect"
                  :disabled="isLoadingSelect"
                  />
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkHandler(); showModalLinkGroups = false}"
                  :loading="isLoadingSelect"
                  :disabled="isLoadingSelect"
                  />
              </div>
            </template>
        </BaseElDialog>
        <BaseElDialog
          :title="$t('aiassist.check_all')"
          :visible.sync="showModalSugerencias"
          @open="handleOpenModalDialog('container-handleOpenModal-sugerencias')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div class="w-full mb-2 lg:mb-4" v-if="form.GrupoSugerido">
            <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-200 block mb-3">{{ $t('app.groups_suggested') }}</label>
            <groups-tags :Grupos="[form.GrupoSugerido]"/>
          </div> 
          <div class="w-full mb-2 lg:mb-4" v-if="form.FechaFinTramiteSugerida">
            <base-ro-input :label="$t('app.date_end_suggested')" :data="form.FechaFinTramiteSugerida"/>
          </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-sugerencias">
              <base-button class="w-full" @click="showModalSugerencias = false" mode="secondary-phantom-blue" :text="$t('app.ignore')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.reject')" @click="() => {cancelSuggestIAHandler(); showModalSugerencias = false}"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {acceptSuggestIAHandler(); showModalSugerencias = false}"/>
            </div>
          </template>
        </BaseElDialog>
      <BaseElDialog
        :title="$t('aiassist.accept_all')"
        :visible.sync="showModalAcceptSuggestIA"
        @open="handleOpenModalDialog('container-handleOpenModal-accept-suggest-ia')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageAcceptSuggestIA }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-accept-suggest-ia">
            <base-button class="w-full" @click="showModalAcceptSuggestIA = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {acceptSuggestIAHandler(); showModalAcceptSuggestIA = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
        :title="$t('aiassist.cancelar_all')"
        :visible.sync="showModalCancelSuggestIA"
        @open="handleOpenModalDialog('container-handleOpenModal-cancel-suggest-ia')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageCancelSuggestIA }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-cancel-suggest-ia">
            <base-button class="w-full" @click="showModalCancelSuggestIA = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {cancelSuggestIAHandler(); showModalCancelSuggestIA = false}"/>
          </div>
        </template>
      </BaseElDialog>
        <input-text-dialog 
          :dialogOpen="showModalRechazo" 
          @toggleDialog="toggleMotivoRechazo" 
          @applyDialog="rechazoDialogHandler"
          header="Rechazar notificaciones" 
          headerValue="Motivo de rechazo" 
          :maxLength='1000'
          typeInput='textarea'
          />
        <input-text-mail-from-white-list-dialog 
          :dialogOpen="showModalWhiteMail" 
          @toggleDialog="newWhiteMailToggleDialog" 
          @applyDialog="applyNewWhiteMailDialog"
          header="Envío de la notificación por correo" 
          headerValue="Lista de emails"
          :idCliente="this.form.idCliente"
          />
      <link-my-groups-dialog 
        :dialogOpen="showModalLinkMyGroups" 
        @toggleDialog="linkMyGroupsToggleDialog" 
        @applyDialog="applyLinkMyGroupsDialog" 
        :idCliente="this.form.idCliente"
        />
      <input-text-mail-from-white-list-vinculados-dialog 
        :dialogOpen="showModalTextoCorreo" 
        @toggleDialog="toggleTextoCorreo" 
        @applyDialog="applyTextoCorreo"
        header="Envío de la notificación por correo" 
        />
      <input-select-dialog 
        header="Seleccionar tipo de documento"
        headerValue="Tipo de documento"
        :dialogOpen="showEditTipoDocumento" 
        :values="tiposDocumentosAeat"
        @toggleDialog="toggleEditTipoDocumento" 
        @applyDialog="editTipoDocumentoHandler"
        />
    </template>
  </detail-layout-two-columns>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { getApiBaseUrl, joinUrl } from '@/config/runtimeConfig'
import { i18n } from '@/i18n'
import GroupsTags from '@/components/GroupsTags.vue'
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import InputTextDialog from '@/components/InputTextDialog.vue'
import InputSelectDialog from '@/components/InputSelectDialog.vue'
import { getNotification } from '@/services/notifications/getNotification'
import { eliminarAnexo } from '@/services/notifications/eliminarAnexo'
import { updateNotificationStatus } from '@/services/notifications/updateNotificationStatus'
import { updateNEO } from '@/services/notifications/updateNEO'
import { modificarmetadatosprincipalesneo } from '@/services/notifications/modificarmetadatosprincipalesneo'
import { editTipoDocumento } from '@/services/notifications/editTipoDocumento'
import { deleteMetadatoNEO } from '@/services/configurations/deleteMetadatoNEO'
import { descargarAdjunto } from '@/services/notifications/descargarAdjunto'
import { descargarPdf } from '@/services/notifications/descargarPdf'
import moment from 'moment'
import NotificationNewDocumentDialog from '../../components/NotificationNewDocumentDialog.vue'
import NotificationNewMetadataDialog from '../../components/NotificationNewMetadataDialog.vue'
import NotificationUpdateMetadataDialog from '../../components/NotificationUpdateMetadataDialog.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { TIPOS_ESTADOS_DESCARGA_DOWNLOADED } from '@/config/tipos-estados-descarga-downloaded'
import { TIPOS_DOCUMENTOS_AEAT } from '@/config/tipos-documentos-aeat'

import InputTextMailFromWhiteListDialog from '@/components/InputTextMailFromWhiteListDialog.vue'
import InputTextMailFromWhiteListVinculadosDialog from '@/components/InputTextMailFromWhiteListVinculadosDialog.vue'
import LinkMyGroupsDialog from '@/components/LinkMyGroupsDialog.vue'
import { sendAvisoCorreoManual } from '@/services/notifications/sendAvisoCorreoManual'
import { sendMailNEOVinculados } from '@/services/notifications/sendMailNEOVinculados'
import { sendRejectNEO } from '@/services/notifications/sendRejectNEO'
import { linkNEOsGroupReasign } from '@/services/configurations/groups/linkNEOsGroupReasign'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import { linkNEOGroupsMultiple } from '@/services/configurations/groups/linkNEOGroupsMultiple'

import TableElementDocRelacionados from '@/components/tables/TableElementDocRelacionados.vue'
import TableElementAdjuntos from '@/components/tables/TableElementAdjuntos.vue'

import { getOrganismoProvinciaByNEO } from '@/services/notifications/getOrganismoProvinciaByNEO'

import { getPeticionesAPIAcciones } from '@/services/clients/getPeticionesAPIAcciones' 
import { ejecutarPeticionApi } from '@/services/notifications/ejecutarPeticionApi'  
import { updateOrganismoProvinciaNEOs } from '@/services/notifications/updateOrganismoProvinciaNEOs'  
import InputSelectOrgProvinceDialog from '@/components/InputSelectOrgProvinceDialog.vue'

import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'
import { getAllCompanies } from '@/services/companies/getAllCompanies'
import { aplicarreglasneos } from '@/services/notifications/aplicarreglasneos'
import { aplicarreglasneosemail } from '@/services/notifications/aplicarreglasneosemail'

import { getUsuariosByGrupo } from '@/services/configurations/groups/getUsuariosByGrupo'
import { asignarusuarioresponsableneos } from '@/services/notifications/asignarusuarioresponsableneos'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'
import BaseAccessibleTable from '@/components/tables/BaseAccessibleTable.vue'

import { aceptarsugerencias } from '@/services/notifications/aceptarsugerencias'
import { rechazarsugerencias } from '@/services/notifications/rechazarsugerencias'
import { enviaraia } from '@/services/notifications/enviaraia'
import { reintentarenviosia } from '@/services/notifications/reintentarenviosia'

export default {
  name: 'notification',
  components: {
    DetailLayoutTwoColumns,
    NotificationNewDocumentDialog,
    NotificationNewMetadataDialog,
    NotificationUpdateMetadataDialog,
    PDFViewerApp,
    InputTextMailFromWhiteListDialog,
    InputTextMailFromWhiteListVinculadosDialog,
    LinkMyGroupsDialog,
    BaseElDialog,
    InputTextDialog,
    GroupsTags,
    InputSelectDialog,
    TableElementDocRelacionados,
    TableElementAdjuntos,
    InputSelectOrgProvinceDialog,
    AccessibleElSelect,
    BaseAccessibleTable,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      lastKey: null,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      loadingOrganismos: false,
      valuesOrganismos: [],
      valuesOrganismosProv: [],
      companies: [],
      showNewDocument: false,
      showNewMetadato: false,
      showUpdateMetadato: false,
      selectedUpdateMetadataId: -1,
      selectedUpdateMetadataCampo: '',
      selectedUpdateMetadataValor: '',
      showPdf: false,
      pdfContainerWidth: 0,
      pdfContainerResizeObserver: null,
      pdfContainerResizeFallbackAttached: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: '',
        icon: 'notification',
        breadcrumb: {},
        nav: [],
        url: 'notifications'
      },
      auxGroupsMail: null,
      showModalWhiteMail: false,
      showModalLinkMyGroups: false,
      showModalRechazo: false,

      // Link groups
      listaGroups: [],
      listaGroupsSelected: [],
      showModalLinkGroups: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,

      showModalLinkGroupsReasig: false,
      groupReasignSelected: null,
      mantenerGrupo: false,

      showModalTextoCorreo: false,

      listaUsers: [],
      showUserResponsable: false,
      userResponsableSelected: null,

      showModalUnlinkUserResponsable: false,

      // Api requests
      peticionesAPIAcciones: [],
      showModalOrgProvince: false,
      actualActionAPIRequest: null,

      estadosDescargaDesconocido: TIPOS_ESTADOS_DESCARGA_DOWNLOADED,
      tiposDocumentosAeat: TIPOS_DOCUMENTOS_AEAT,
      listaAcciones: [
        { IdAccion: 102, Descripcion: i18n.t('groups.reasig') },
        { IdAccion: 103, Descripcion: i18n.t('groups.link') },
        { IdAccion: 500, Descripcion: i18n.t('app.user_responsable_reasign') },
        { IdAccion: 501, Descripcion: i18n.t('app.user_responsable_unlink') },
        { IdAccion: 600, Descripcion: i18n.t('aiassist.accept_all') },
        { IdAccion: 601, Descripcion: i18n.t('aiassist.cancelar_all') },
        // { IdAccion: 602, Descripcion: i18n.t('aiassist.send_ai') },
        { IdAccion: 603, Descripcion: i18n.t('aiassist.resend_ai') },
        { IdAccion: 700, Descripcion: i18n.t('procedings.new_short') },
      ],
      showEditMode: false,
      showModalSugerencias: false,
      form: {
        Asunto: '',
        Adjuntos: [],
        DocumentosRelacionados: [],
        Distribuidor: '',
        Empresa: '',
        IdEstado: null,
        Estado: '',
        FechaDisposicion: '',
        IDInterno: 0,
        Organismo: '',
        Sede: '',
        idSede: -10,
        OrganismoSelect: -10,
        company: -10,
        FechaDescargaDateTime: null,
        FechaDisposicionDateTime: null,
        full_text: '',
        resumen: '',
        idEstadoSugerencia: null,
        EstadoSugerencia: null,
        GrupoSugerido: null,
        FechaFinTramiteSugerida: null,
        TieneSugerencias: false,
        TicketID: '',
        FechaDescarga: '',
        CIFTitular: '',
        NombreEmpresa: '',
        fechaFinTramite: '',
        OrganismoProvincia: null,
        Metadatos: [],
        enlaceDescarga: '',
        UltimoError: '',
        NeoAMano: false,
        DescargadaAutomaticamente: false,
        EsPropietario: false,
        MotivoRechazo: '',
        TieneDestinatarioAutomatico: false,
        idUltimaReglaAplicada: null,
        TieneReglaAplicada: false,
        TieneDiligencias: false,
        UltimaReglaAplicada: null,
        Grupos: [],
        GrupoPropietarioAnterior: [],
        GrupoPropietarioAnteriorNombre: null,
        UsuarioResponsable: null,
      },
      rules: {
        Empresa: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        location: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        Asunto: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        OrganismoSelect: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        company: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        FechaDescargaDateTime: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        FechaDisposicionDateTime: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      },
      url: '',
      documentError: undefined,
      enableUploader: false,
      lastAdjuntoVisible: null,
      lastRelacionadoVisible: null,
      notificationType: null,
      // notificationActions: null,
      showModal: false,
      showModalArchivar: false,
      showModalDelete: false,
      showModalApplyRules: false,
      showModalApplyRulesEmail: false,
      showModalTramitar: false,
      showEditTipoDocumento: false,

      showModalAcceptSuggestIA: false,
      showModalCancelSuggestIA: false,

      selectedIdDocument: -1,
      processMessage: this.$i18n.t('app.confirm_download_neo'),
      processMessageDelete: '¿Estás seguro que deseas borrar la notificación?',
      processMessageApplyRules: this.$i18n.t('rules.apply_dialog_text'),
      processMessageApplyRulesEmail: this.$i18n.t('rules.apply_dialog_text'),
      processMessageTramitar: '¿Estás seguro que deseas pasar a tramitadas las notificaciones seleccionadas?',
      processMessageArchivar: '¿Estás seguro que deseas archivar la notificación sin haberla descargado previamente?',
      processMessageUnlinkUserResponsable: this.$i18n.t('app.user_responsable_unlink_msg2'),
      processMessageAcceptSuggestIA: this.$i18n.t('aiassist.accept_all_confirm_detail'),
      processMessageCancelSuggestIA: this.$i18n.t('aiassist.cancelar_all_confirm_detail'),
      selectedAction: null,
      actualFilterContent: null,
      processMessageVincularReparto: this.$i18n.t('groups.link_reparto_info'),
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandlerDefault'
    },
    'form.resumen': {
      deep: true,
      inmediate: true,
      handler: 'watchFormHandler'
    },
    'form.full_text': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.FechaDisposicionDateTime': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.FechaDescargaDateTime': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.fechaFinTramite': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    showModalLinkGroupsReasig: async function (val, oldVal) {
      this.loadGroupsSimple(val, true)
    },
    showModalLinkGroups: async function (val, oldVal) {
      this.loadGroupsSimple(val)
    },
    showUserResponsable: async function (val, oldVal) {
      this.loadUsersSimple(val)
    },
    showPdf (value) {
      if (value) {
        this.$nextTick(() => {
          this.updatePdfContainerWidth()
        })
      }
    },
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    peticionAPIName () {
      return this.isLower1024 ? this.$t('app.api') : this.$t('app.send_petition_api')
    },
    notificationActions () {
      let notificationActions = []
      if (this.notificationType !== undefined && parseInt(this.notificationType) !== 99999) {
        const notifications = this.$store.getters['app/actionsForSelect'](parseInt(this.notificationType))
        if (notifications !== null && notifications?.Acciones) {
          const actions = notifications.Acciones
          // Control por grupo propietario
          if (this.role === 'UsuarioConsulta') {
            notificationActions = []
          } else {
            if (!this.form.EsPropietario) {
              // Solo permitimos reenvio por email para neos descargadas si no eres Propietario
              if (this.hasModuleAsignacionEmailReglas) {
                notificationActions = actions.filter(x => x.IdAccion === 9 || x.IdAccion === 16 || x.IdAccion === 19 || x.IdAccion === 20)
              } else {
                notificationActions = actions.filter(x => x.IdAccion === 9 || x.IdAccion === 19)
              }
            } else {
              if (this.form.IdEstado !== 7) {
                notificationActions = this.listaAcciones
              } 
              if (notificationActions == null) notificationActions = []
              // Eliminamos descargar documentos
              notificationActions = notificationActions.concat(actions.filter(x => x.IdAccion !== 8))
              // Solo eliminamos borrar para Usuario (enviar avisos debería poder hacerlo)
              if (this.role === 'Usuario') {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 3)
              }
              if (this.role !== 'SuperAdministrador') {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 21)
              }
              if (!this.hasModuleAsignacionEmailReglas) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 16 && x.IdAccion !== 20)
              }
              // Quitamos reasignar para los estados de pendiente de aprobación
              if ([22, 23, 24].includes(this.form.IdEstado)) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 102 && x.IdAccion !== 103)
              }
              // Quitamos desvincular usuario responsable si no tiene usuario responsable asignado
              if (!this.form.UsuarioResponsable) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 501)
              }
              // Quitamos crear nueva diligencia para notificaciones que no sean de AEAT o que no tengan el número de diligencia en los metadatos
              if (!this.isValidCreateProceding) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 700)
              }
              // Acciones sugerencias de IA
              if (!this.hasModuleAsistenciaIA || !this.form.TieneSugerencias) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 600 && x.IdAccion !== 601)
              }
            }
            // Quitamos enviar email a correos vinculados en caso de que alguna no tengan emails asignados
            if (!this.form.TieneDestinatarioAutomatico) {
              notificationActions = notificationActions.filter(x => x.IdAccion !== 16 && x.IdAccion !== 20)
            } 
            // Quitamos si no tiene modulo de flujo y no es un rol alto quitamos todas las acciones de ese modulo
            if (!this.hasModuleFlujoAceptacion && this.role !== 'SuperAdministrador' && this.role !== 'SuperAdminDistribuidor') {
              notificationActions = notificationActions.filter(x => x.IdAccion !== 17 && x.IdAccion !== 18 && x.IdAccion !== 19 && x.IdAccion !== 20)
            }
            // Quitamos acciones de enviar y reenviar a IA si no es superadmin
            // Enviar IA solo si no tiene idEstadoSugerencia y reenviar IA solo si tiene idEstadoSugerencia en error (id 5)
            if (this.role !== 'SuperAdministrador') {
              notificationActions = notificationActions.filter(x => x.IdAccion !== 22 && x.IdAccion !== 603)
            } else {
              if (this.form.idEstadoSugerencia === 5) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 22)
              }
              if (this.form.idEstadoSugerencia !== 5) {
                notificationActions = notificationActions.filter(x => x.IdAccion !== 603)
              }
            }
          }
        }
      }
      return notificationActions
    },
    usersForAccessibleSelect () {
      return this.listaUsers.map(user => ({
        id: user.IdUsuario,
        name: user.Usuario,
        value: user.IdUsuario
      }))
    },
    idGrupoPropietario () {
      return this.form?.Grupos?.filter(x => x.Propietario === true)[0]?.idGrupo || -1
    },
    showButtonEditMode () {
      return this.form.idSede === -1 && this.showEditMode === false && this.form.EsPropietario && this.role !== 'UsuarioCosulta'
    },
    hasModuleAPIRequests () {
      return this.$store.getters['auth/hasModuleAPIRequests']
    },
    hasModuleContestacionDiligencias () {
      return this.$store.getters['auth/hasModuleContestacionDiligencias']
    },
    isValidCreateProceding () {
      return this.hasModuleContestacionDiligencias && 
        this.isFromAEAT && 
        this.form.Metadatos.some(x => x.Campo === 'AEAT_NUMERO_DILIGENCIA')
    },
    peticionesAPIAccionesFilter () {
      if (!this.hasModuleAPIRequests || 
        this.role === 'UsuarioCosulta' ||
        !this.form.EsPropietario
      ) { 
        return [] 
      }
      const res = []
      this.peticionesAPIAcciones.forEach(peticionAPI => {
        if (peticionAPI.idEstadosIniciales.includes(this.form.IdEstado)) res.push(peticionAPI)
      })
      return res
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    isEmptyList: function () {
      return this.listaGroups === undefined || this.listaGroups === null || this.listaGroups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.listaGroups.length === this.listaGroupsSelected.length) return true
      else return false
    },
    processMessageVincularRepartoActive () {
      return this.listaGroups && this.listaGroups.filter(x => this.listaGroupsSelected.includes(x.id)).filter(x => x.idTipo === 3).length > 0
    },
    isFromAEAT () {
      return this.form.idSede === 203
    },
    hasModulePresentacionesAEAT () {
      return this.$store.getters['auth/hasModulePresentacionesAEAT']
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails']
    },
    hasModuleAsignacionEmailReglas () {
      return this.$store.getters['auth/hasModuleAsignacionEmailReglas']
    },
    hasModuleOrgProvinces () {
      return this.$store.getters['auth/hasModuleOrgProvinces']
    },
    hasModuleFlujoAceptacion () {
      return this.$store.getters['auth/hasModuleFlujoAceptacion']
    }, 
    hasModuleAsistenciaIA () {
      return this.$store.getters['auth/hasModuleAsistenciaIA'] 
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    notificationId: function () {
      return parseInt(this.$route.params.id)
    },
    canUseCopyClipboard: function () {
      return this.form.enlaceDescarga !== null && this.form.enlaceDescarga !== undefined && this.form.enlaceDescarga !== ''
    },
    isErrorState: function () {
      return this.form.IdEstado === -1 || this.form.IdEstado === -2 || this.form.IdEstado === -3 || this.form.IdEstado === 6
    },
    listaGroupsGrouping () {
      if (!this.isEmptyList) {
        const options = []
        this.listaGroups.forEach(x => {
          if (options.filter(y => y.label === x.group).length === 0) {
            options.push(
              { label: x.group, options: [] }
            )
          }
        })
        this.listaGroups.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.group)
          options[index].options.push(
            {
              value: x.id,
              label: x.value,
            }
          )
        })
        return options
      }
      return []
    },
    companiesForAccessibleSelect () {
      return this.companies.map(company => ({
        id: company.id,
        name: company.label,
        value: company.id
      }))
    },
    organismosForAccessibleSelect () {
      return this.valuesOrganismos.map(organismo => ({
        id: organismo.id,
        name: organismo.label,
        value: organismo.value,
      }))
    },
    organismosProvForAccessibleSelect () {
      return this.valuesOrganismosProv.map(organismo => ({
        id: organismo.id,
        name: organismo.label,
        value: organismo.id,
      }))
    },
    groupsForAccessibleSelect () {
      return this.listaGroupsGrouping.map(group => ({
        label: group.label,
        options: group.options.map(option => ({
          id: option.value,
          name: option.label,
          value: option.value
        }))
      }))
    },
    metadatosColumns () {
      return [
        { key: 'Campo', label: 'Campo', align: 'left', minWidth: '200px' },
        { key: 'Valor', label: 'Valor', align: 'left', minWidth: '200px' },
        { key: 'actions', label: 'Acciones', width: '80px', align: 'center' },
      ]
    },
  },
  created: async function () {
    this.$store.commit('setIsLoading', true)
    const notificationId = this.notificationId

    this.filterByParamsData()

    await this.downloadNotificationData(notificationId)
    this.suggestsHandler()
    // console.log('Route params:')
    // console.log(this.$route.params)
    this.notificationType = this.$route.params.type === undefined ? this.form.IdEstado : this.$route.params.type

    const breadcrumbs = []
    const notice = this.$route.params.notice
    if (this.notificationType !== undefined && parseInt(this.notificationType) !== 99999) {
      if (notice !== undefined && notice !== null && notice !== '') {
        if (notice === 'error') {
          this.header.url = 'notifications/notices/error'
          breadcrumbs.push({ path: 'notifications/notices/error', name: this.$i18n.t('app.noticesError') })
        } 
      } else {
        breadcrumbs.push({ path: '' + parseInt(this.notificationType), name: this.$i18n.t('app.notifications') })
        if (!this.$route.params.backGeneral) {
          this.header.url = this.notificationType !== null ? '' + parseInt(this.notificationType) : this.header.url
        }
      }
    } else {
      if (notice !== undefined && notice !== null && notice !== '') {
        if (notice === 'error') {
          this.header.url = 'notifications/notices/error'
          breadcrumbs.push({ path: 'notifications/notices/error', name: this.$i18n.t('app.noticesError') })
        } 
      } else {
        breadcrumbs.push({ path: 'notifications', name: this.$i18n.t('app.notifications') })
      }
    }
    const asuntoBreadCrumb = this.form.Asunto ? this.form.Asunto : 'Sin asunto'
    breadcrumbs.push({ path: '', name: this.truncate(asuntoBreadCrumb, 30, false) })
    this.$store.commit('app/setheaderBreadCrumb', asuntoBreadCrumb)
    this.header.breadcrumb = breadcrumbs
    this.header.title = this.headerTitle()

    if (this.form.Adjuntos !== undefined && this.form.Adjuntos.length > 0) {
      if (this.form.Adjuntos[0].Extension.toUpperCase() === 'PDF') {
        this.showAdjunto(this.form.Adjuntos[0])
      }
    } else if (this.form.DocumentosRelacionados !== undefined && this.form.DocumentosRelacionados.length > 0) {
      if (this.form.DocumentosRelacionados[0].Extension.toUpperCase() === 'PDF') {
        this.showAdjunto(this.form.DocumentosRelacionados[0], true)
      }
    }
    this.updateGetPeticionesApiAcciones()

    if (this.form.idSede === -1) {
      const data = await getAllCompanies({ idEmpresaCert: this.form.idCliente })
      if (data.blnError) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        data.CIFSEmpresa.forEach(row => {
          this.companies.push({ id: row.IdCIFEmpresa, value: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.NombreCIF })
        })
      }
    }

    // Tiempo de cortesía por evitar complicar el flujo
    setTimeout(() => {
      this.$store.commit('setIsLoading', false)
    }, 200)
  },
  mounted () {
    this.resetControlFormChanges()
    this.$nextTick(() => {
      this.setupPdfContainerObserver()
    })
  },
  beforeDestroy () {
    this.teardownPdfContainerObserver()
  },
  methods: {
    loadUsersSimple: async function (val) {
      this.isLoadedData = false
      try {
        if (val) {
          const data = await getUsuariosByGrupo({ idGrupo: this.idGrupoPropietario })
          if (data.blnError) {
            this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
          } else {
            this.listaUsers = data.respuesta
          }
        } else {
          this.listaUsers = []
          this.userResponsableSelected = null
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
    toggleDialogUserResponsable () {
      this.showUserResponsable = !this.showUserResponsable
    },
    unlinkUserResponsable: async function () {
      this.showModalUnlinkUserResponsable = !this.showModalUnlinkUserResponsable
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    updatePdfContainerWidth () {
      try {
        if (!this.$refs.pdfContainer) return
        const { width } = this.$refs.pdfContainer.getBoundingClientRect()
        this.pdfContainerWidth = Math.round(width)
      } catch (error) {
        console.error('Error al actualizar el ancho del contenedor PDF:', error)
      }
    },
    setupPdfContainerObserver () {
      try {
        if (!this.$refs.pdfContainer) return
        this.updatePdfContainerWidth()
        if (typeof ResizeObserver !== 'undefined') {
          if (this.pdfContainerResizeObserver) return
          this.pdfContainerResizeObserver = new ResizeObserver(entries => {
            if (!entries || entries.length === 0) return
            const { width } = entries[0].contentRect
            this.pdfContainerWidth = Math.round(width)
          })
          this.pdfContainerResizeObserver.observe(this.$refs.pdfContainer)
        } else if (!this.pdfContainerResizeFallbackAttached) {
          window.addEventListener('resize', this.updatePdfContainerWidth)
          this.pdfContainerResizeFallbackAttached = true
        }
      } catch (error) {
        console.error('setupPdfContainerObserver:', error)
      }
    },
    teardownPdfContainerObserver () {
      try {
        if (this.pdfContainerResizeObserver && this.$refs.pdfContainer) {
          this.pdfContainerResizeObserver.unobserve(this.$refs.pdfContainer)
          this.pdfContainerResizeObserver.disconnect()
          this.pdfContainerResizeObserver = null
        }
        if (this.pdfContainerResizeFallbackAttached) {
          window.removeEventListener('resize', this.updatePdfContainerWidth)
          this.pdfContainerResizeFallbackAttached = false
        }
      } catch (error) {
        console.error('teardownPdfContainerObserver:', error)
      }
    },
    // Al recibir el foco en el date-picker hacemos visible su popover (si no es chrome) 
    onFocusDatePickerFinTramite () {
      // Llama a la mejora de accesibilidad SIEMPRE antes de comprobar el navegador
      setTimeout(() => { this.enhanceDatePickerAccessibility('.datePickerFinTramite-popover') }, 50)
      if (this.detectChrome()) return
      setTimeout(() => { this.toggleDisplayPopoverDatepicker('.datePickerFinTramite-popover', true) }, 100)
    },
    onFocusDatePickerFechaDisposicion () {
      setTimeout(() => { this.enhanceDatePickerAccessibility('.datePickerFechaDisposicion-popover') }, 50)
      if (this.detectChrome()) return
      setTimeout(() => { this.toggleDisplayPopoverDatepicker('.datePickerFechaDisposicion-popover', true) }, 100)
    },
    onFocusDatePickerFechaDescarga () {
      setTimeout(() => { this.enhanceDatePickerAccessibility('.datePickerFechaDescarga-popover') }, 50)
      if (this.detectChrome()) return
      setTimeout(() => { this.toggleDisplayPopoverDatepicker('.datePickerFechaDescarga-popover', true) }, 100)
    },
    // Al recibir el blur del date-picker redirigimos el foco al siguiente elemento dependiendo de si se avanza o se retrocede
    // Además ocultamos el popover
    // (Si no es chrome)
    onBlurDatePickerFinTramite () {
      setTimeout(() => { this.enhanceDatePickerAccessibility('.datePickerFinTramite-popover') }, 50)
      if (this.detectChrome()) return
      setTimeout(() => { this.focusElementByKey() }, 100)
      setTimeout(() => { this.toggleDisplayPopoverDatepicker('.datePickerFinTramite-popover', false) }, 300)
    },
    onBlurDatePickerFechaDisposicion () {
      setTimeout(() => { this.enhanceDatePickerAccessibility('.datePickerFechaDisposicion-popover') }, 50)
      if (this.detectChrome()) return
      setTimeout(() => { this.focusElementByKey() }, 100)
      setTimeout(() => { this.toggleDisplayPopoverDatepicker('.datePickerFechaDisposicion-popover', false) }, 300)
    },
    onBlurDatePickerFechaDescarga () {
      setTimeout(() => { this.enhanceDatePickerAccessibility('.datePickerFechaDescarga-popover') }, 50)
      if (this.detectChrome()) return
      setTimeout(() => { this.focusElementByKey() }, 100)
      setTimeout(() => { this.toggleDisplayPopoverDatepicker('.datePickerFechaDescarga-popover', false) }, 300)
    },
    toggleEditMode () {
      this.showEditMode = !this.showEditMode
    },
    toggleModalOrgProvince () {
      this.showModalOrgProvince = !this.showModalOrgProvince
    },
    showActionModalPetition: function (action) {
      this.actualActionAPIRequest = action
      if (action.OrganismoProvinciaRequerido && !this.form.OrganismoProvincia && this.hasModuleOrgProvinces) {
        this.toggleModalOrgProvince()
      } else {
        this.sendPetitionAPIHandler()
      }
    },
    updateGetPeticionesApiAcciones () {
      if (((this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')) ||
        ((this.role === 'Administrador' || this.role === 'Usuario') && this.hasModuleAPIRequests)) {
        this.getPeticionesAPIAcciones()
      } 
    },
    getPeticionesAPIAcciones: async function () {
      try {
        this.peticionesAPIAcciones = []
        this.$store.commit('setIsLoading', true)
        const payload = { NombreCliente: this.form.Empresa }
        const response = await getPeticionesAPIAcciones(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.peticionesAPIAcciones = response.respuesta
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    sendUpdateOrgProvinceAndPetitionAPI: async function (form) {
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          AsociarOrganismoNEO: form.switch,
          idOrganismoProvincia: form.value, 
          idNEOs: [this.notificationId],
        }
        const response = await updateOrganismoProvinciaNEOs(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.showModalOrgProvince = false
          this.sendPetitionAPIHandler()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
      }
    },
    sendPetitionAPIHandler: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idPeticion: this.actualActionAPIRequest.idPeticion, 
          idNEOs: [this.notificationId],
        }
        const response = await ejecutarPeticionApi(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.showModalOrgProvince = false
          this.doFeedback('Enviado correctamente', 'success')
          const notificationId = this.notificationId
          await this.downloadNotificationData(notificationId)
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleEditTipoDocumento (row) {
      if (row) this.selectedIdDocument = row.idAdjunto
      this.showEditTipoDocumento = !this.showEditTipoDocumento
    },
    goDetailRule () {
      const id = this.form.idUltimaReglaAplicada
      this.$router.push({ name: 'configurations/rules/details', params: { id } })
    },
    goDetailClient () {
      const id = this.form.idCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    linkMyGroupsToggleDialog () {
      this.showModalLinkMyGroups = !this.showModalLinkMyGroups
    },
    applyNewWhiteMailDialog: async function (form) {
      if (form.GestionarListaBlancaGrupos) {
        this.auxGroupsMail = {
          valueTo: form.valueTo,
          valueCC: form.valueCC,
          valueCCO: form.valueCCO,
          TextoCorreo: form.TextoCorreo,
          AsuntoCorreo: form.AsuntoCorreo,
        }
        this.linkMyGroupsToggleDialog()
      } else {
        this.newWhiteMailDialogHandler(form)
      }
      this.showModalWhiteMail = false
    },
    applyLinkMyGroupsDialog (grupos) {
      this.newWhiteMailDialogHandler(this.auxGroupsMail, grupos)
    },
    applyTextoCorreo (form) {
      this.sendMailAVinculadosHandler(form)
    },
    toggleTramitar () {
      this.showModalTramitar = !this.showModalTramitar
    },
    tramitarHandler () {
      this.submitAction()
    },
    editTipoDocumentoHandler: async function (codigoTipoDocumento) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          codigoTipoDocumento: codigoTipoDocumento,
          idAnexo: this.selectedIdDocument
        }
        const response = await editTipoDocumento(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.showEditTipoDocumento = false
          const notificationId = this.notificationId
          await this.downloadNotificationData(notificationId)
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newWhiteMailDialogHandler: async function (emails, grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Emails: emails.valueTo, 
          EmailsCC: emails.valueCC, 
          EmailsCCO: emails.valueCCO, 
          idNotificaciones: [this.notificationId],
          idGrupos: grupos,
          TextoCorreo: emails.TextoCorreo,
          AsuntoCorreo: emails.AsuntoCorreo,
        }
        const response = await sendAvisoCorreoManual(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.showModalLinkMyGroups = false
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    filterByParamsData () {
      const data = this.$route.params.data
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'contenido') {
            this.actualFilterContent = filter.data
          } 
        })
      }
    },
    goBack: function () {
      this.$router.push({ name: this.header.url })
    },
    copyLinkDownload: function () {
      // console.log(process.env)
      
      const url = joinUrl(getApiBaseUrl(), this.form.enlaceDescarga)

      navigator.clipboard.writeText(url)

      this.doFeedback('Enlace de descarga copiado en el portapapeles', 'success')
    },
    selectActionIcon: function (action) {
      var icon = ''
      switch (action.IdAccion) {
        case 1:
          icon = 'download'
          break
        case 2:
          icon = 'retry'
          break
        case 3:
          icon = 'trash'
          break
        case 8:
          icon = 'download'
          break
        case 9: case 16:
        case 19: case 20:
          icon = 'mailsend'
          break
        case 21:
          icon = 'automation'
          break
        case 102:
          icon = 'groupchange'
          break
        case 103:
          icon = 'groupadd'
          break
        case 500:
          icon = 'userchange'
          break
        case 501:
          icon = 'userremove'
          break
        case 600:
        case 22:
        case 603:
          icon = 'suggestaccept'
          break
        case 601:
          icon = 'suggestcancel'
          break
        case 700:
          icon = 'proceding'
          break
        default:
          icon = 'changestatus'
      }
      return icon
    },
    selectIcon: function (row) {
      return row.icon
    },
    headerTitle: function () {
      let header = 'Detalle notificación'
      const notifications = this.$store.getters['app/notificationsStatus']
      const notification = notifications.filter(sc => sc.idEstado === this.notificationType)
      if (notification.length > 0) {
        header = notification[0].Descripcion
      }
      return header
    },
    // eslint-disable-next-line camelcase
    watchFormHandlerDefault: function ({ fechaFinTramite, FechaDisposicionDateTime, FechaDescargaDateTime }) {
      // eslint-disable-next-line camelcase
      if (fechaFinTramite !== undefined && moment(fechaFinTramite).isValid()) {
        this.form.fechaFinTramite = moment(fechaFinTramite).format('YYYY-MM-DD')
      } else {
        this.form.fechaFinTramite = ''
      }
      if (FechaDisposicionDateTime !== undefined && moment(FechaDisposicionDateTime).isValid()) {
        this.form.FechaDisposicionDateTime = moment(FechaDisposicionDateTime).format('YYYY-MM-DD HH:mm')
      } else {
        this.form.FechaDisposicionDateTime = ''
      }
      if (FechaDescargaDateTime !== undefined && moment(FechaDescargaDateTime).isValid()) {
        this.form.FechaDescargaDateTime = moment(FechaDescargaDateTime).format('YYYY-MM-DD HH:mm')
      } else {
        this.form.FechaDescargaDateTime = ''
      }
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    toggleDialogs: function () {
      this.showNewDocument = !this.showNewDocument
    },
    toggleDialogMetadato: function () {
      this.showNewMetadato = !this.showNewMetadato
    },
    toggleDialogUpdateMetadato: function () {
      this.showUpdateMetadato = !this.showUpdateMetadato
    },
    toggleTextoCorreo () {
      this.showModalTextoCorreo = !this.showModalTextoCorreo
    },
    applyDialogHandler: async function () {
      // this.toggleDialogs()
      const notificationId = this.notificationId
      await this.downloadNotificationData(notificationId)
    },
    applyDialogMetadatoHandler: async function () {
      this.toggleDialogMetadato()
      const notificationId = this.notificationId
      await this.downloadNotificationData(notificationId)
    },
    applyDialogUpdateMetadatoHandler: async function () {
      this.toggleDialogUpdateMetadato()
      const notificationId = this.notificationId
      await this.downloadNotificationData(notificationId)
    },
    handleClick: function (tab, event) {
      // console.log(tab, event)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const payload = {
              idNEO: this.notificationId,
              comentario: this.form.full_text ? this.form.full_text : null,
              fechaFinTramite: this.form.fechaFinTramite ? moment(this.form.fechaFinTramite).format('YYYY-MM-DD[T00:00:00]') : null,
              idOrganismoProvincia: this.form.OrganismoProvincia ? this.form.OrganismoProvincia : null,
              Resumen: this.form.resumen ? this.form.resumen : null,
            }
            const response = await updateNEO(payload)
            if (response.blnError) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              if (this.showEditMode) {
                const payload = {
                  idNEO: this.notificationId,
                  idCIFEmpresa: this.form.company,
                  idOrganismo: this.form.OrganismoSelect,
                  Asunto: this.form.Asunto,
                  FechaPublicacion: this.form.FechaDisposicionDateTime,
                  FechaDescarga: this.form.FechaDescargaDateTime,
                }
                const responseSedeEmail = await modificarmetadatosprincipalesneo(payload)
                if (responseSedeEmail.blnError) {
                  this.doFeedback(responseSedeEmail.msgError + ' [Código de error: ' + responseSedeEmail.codError + ']')
                } else {
                  this.toggleEditMode()
                  this.doFeedback('Datos guardados correctamente', 'success')
                  const notificationId = this.notificationId
                  await this.downloadNotificationData(notificationId)
                  this.showModalApplyRulesEmail = true 
                }
              } else {
                this.doFeedback('Datos guardados correctamente', 'success')
                this.resetControlFormChanges()
              }
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
            this.$store.commit('setIsLoading', false)
            return false
          }
          this.$store.commit('setIsLoading', false)
        })
      } catch (error) {
        console.log(error)
        this.doFeedback()
      }
    },
    executeIAAction: async function (apiFn) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idsNEOs: [this.notificationId] }
        const response = await apiFn(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        await this.downloadNotificationData(this.notificationId)
      }
    },
    acceptSuggestIAHandler: async function () {
      await this.executeIAAction(aceptarsugerencias)
    },
    enviaraiaHandler: async function () {
      await this.executeIAAction(enviaraia)
    },
    reintentarenviosiaHandler: async function () {
      await this.executeIAAction(reintentarenviosia)
    },
    cancelSuggestIAHandler: async function () {
      await this.executeIAAction(rechazarsugerencias)
    },
    toggleModalSugerencias () {
      this.showModalSugerencias = !this.showModalSugerencias
    },
    suggestsHandler () {
      if (this.hasModuleAsistenciaIA && this.form.TieneSugerencias && this.form.EsPropietario) {
        this.toggleModalSugerencias()
      }
    },
    downloadNotificationData: async function (notificationId) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idNEO: notificationId
        }
        const notification = await getNotification(params)
        if (notification.blnError) {
          this.doFeedback(notification.msgError + ' [Código de error: ' + notification.codError + ']')
        }
        this.setNotification(notification.respuesta)
      } catch (error) {
        console.error(error)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    setNotification: function (notification) {
      this.form.Distribuidor = notification.Distribuidor
      this.form.Empresa = notification.Empresa.Empresa
      this.form.idCliente = notification.Empresa.Id
      this.form.Sede = notification.Sede.Sede
      this.form.idSede = notification.Sede.Id
      this.form.Organismo = notification.Organismo
      this.form.IdEstado = notification.Estado.Id
      this.form.Estado = notification.Estado.Estado
      this.form.Asunto = notification.Asunto
      this.form.IDInterno = notification.IDInterno
      this.form.FechaDisposicion = moment(notification.FechaDisposicion).format('DD-MM-YYYY HH:mm')
      this.form.full_text = notification.Comentarios
      this.form.resumen = notification.Resumen
      this.form.EstadoSugerencia = notification.EstadoSugerencia
      this.form.idEstadoSugerencia = notification.idEstadoSugerencia
      this.form.GrupoSugerido = notification.GrupoSugerido
      this.form.FechaFinTramiteSugerida = notification.FechaFinTramiteSugerida ? moment(notification.FechaFinTramiteSugerida).format('DD-MM-YYYY') : null
      this.form.TieneSugerencias = notification.TieneSugerencias
      this.form.MotivoRechazo = notification.MotivoRechazo
      this.form.TieneDestinatarioAutomatico = notification.TieneDestinatarioAutomatico
      this.form.idUltimaReglaAplicada = notification.idUltimaReglaAplicada
      this.form.TieneReglaAplicada = notification.TieneReglaAplicada
      this.form.TieneDiligencias = notification.TieneDiligencias
      this.form.UltimaReglaAplicada = notification.UltimaReglaAplicada
      this.form.Grupos = notification.Grupos
      this.form.GrupoPropietarioAnterior = notification.GrupoPropietarioAnterior ? [notification.GrupoPropietarioAnterior] : []
      this.form.GrupoPropietarioAnteriorNombre = notification.GrupoPropietarioAnterior?.Nombre ? notification.GrupoPropietarioAnterior?.Nombre : null
      this.form.UsuarioResponsable = notification.UsuarioResponsable ? notification.UsuarioResponsable : null
      this.form.TicketID = notification.TicketID
      // Formato para fechas dependiendo del tipo de estado
      const yearFechaDescarga = new Date(notification.FechaDescarga).getFullYear()
      this.form.FechaDescarga = yearFechaDescarga >= 2000 ? moment(notification.FechaDescarga).format('DD-MM-YYYY HH:mm') : ' - '
      if (this.form.FechaDescarga === ' - ' && this.estadosDescargaDesconocido.includes(this.form.IdEstado)) this.form.FechaDescarga = 'Desconocido'
      this.form.CIFTitular = notification.CIFTitular
      this.form.NombreEmpresa = notification.NombreCIF
      setTimeout(() => {
        this.form.company = notification.idCIFEmpresa
      }, 500)
      this.form.FechaDisposicionDateTime = notification.FechaDisposicion
      this.form.FechaDescargaDateTime = notification.FechaDescarga
      this.form.fechaFinTramite = notification.FechaFinTramite
      if (notification.OrganismoProvincia) {
        const actualOrgProvincia = { 
          id: notification.OrganismoProvincia.idOrganismoProvincia, 
          label: this.formatNombreOrgProvince(notification.OrganismoProvincia),
        }
        this.valuesOrganismosProv.push(actualOrgProvincia)
        setTimeout(() => {
          this.form.OrganismoProvincia = actualOrgProvincia.id
          this.resetControlFormChanges()
        }, 200)
      }
      const actualOrg = { 
        id: notification.idOrganismo, 
        label: this.formatNombreOrg({
          Nombre: notification.Organismo,
          CIF: notification.CIFEmisor,
        }),
        value: notification.idOrganismo,
      }
      this.valuesOrganismos.push(actualOrg)
      setTimeout(() => {
        this.form.OrganismoSelect = notification.idOrganismo
        this.resetControlFormChanges()
      }, 500)

      this.form.enlaceDescarga = notification.EnlaceDescarga
      this.form.UltimoError = notification.UltimoError
      this.form.NeoAMano = notification.NeoAMano
      this.form.DescargadaAutomaticamente = notification.DescargadaAutomaticamente
      this.form.EsPropietario = notification.EsPropietario

      const adjuntos = notification.Adjuntos
      adjuntos.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      this.$set(this.form, 'Adjuntos', adjuntos)

      const documentosRelacionados = notification.DocumentosRelacionados
      documentosRelacionados.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      this.$set(this.form, 'DocumentosRelacionados', documentosRelacionados)

      if (notification.MetadatosAdicionales !== undefined) {
        this.form.Metadatos = notification.MetadatosAdicionales
          .filter((x) => x.Valor !== '' && x.Campo !== 'XmlNotificacion')
          .sort((a, b) => {
            if (a.Campo < b.Campo) return -1
            if (a.Campo > b.Campo) return 1
            return 0
          })
      }
      this.resetControlFormChanges()
    },
    newDocument: async function () {
      this.toggleDialogs()
    },
    newMetadato: async function () {
      this.toggleDialogMetadato()
    },
    editMetadatoAdicional: async function (row) {
      this.selectedUpdateMetadataId = row.idMetadato
      this.selectedUpdateMetadataCampo = row.Campo
      this.selectedUpdateMetadataValor = row.Valor
      this.toggleDialogUpdateMetadato()
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await deleteMetadatoNEO({ idMetadato: row.idMetadato })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Metadato eliminado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
        const notificationId = this.notificationId
        await this.downloadNotificationData(notificationId)
      }
    },
    deleteDocumentoRelacionado: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await eliminarAnexo(row.idAdjunto)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Documento eliminado correctamente', 'success')
          const notificationId = this.notificationId
          await this.downloadNotificationData(notificationId)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    showAdjunto: async function (row, withoutEvent) {
      this.form.Adjuntos.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      this.form.DocumentosRelacionados.forEach(key => {
        key.visible = false
        key.icon = key.Extension.trim() === 'pdf' || key.Extension.trim() === 'PDF' ? 'eye' : 'download'
      })
      if (this.showPdf === true && this.lastAdjuntoVisible !== null && this.lastAdjuntoVisible.idAdjunto === row.idAdjunto) {
        this.showPdf = false
      } else {
        if (row.Extension.trim() === 'pdf' || row.Extension.trim() === 'PDF') {
          await this.showPDFHandler(row.idAdjunto, withoutEvent)
          this.showPdf = true
          row.visible = this.showPdf
          row.icon = 'eyeslash'
          this.lastAdjuntoVisible = row
        } else {
          this.showPdf = false
          await this.downloadAdjunto(row)
        }
      }
    },
    onDocumentErrored: function (e) {
      this.documentError = e.text
      console.log(this.documentError)
    },
    downloadAdjunto: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idAdjunto: row.idAdjunto
        }
        const response = await descargarAdjunto(row.idAdjunto, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        // const headerVal = response.headers['content-disposition']
        let filename = row.Nombre + '.' + row.Extension
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    showPDFHandler: async function (idAdjunto) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idAdjunto: idAdjunto,
          automatico: true
        }

        const adjunto = await descargarPdf(idAdjunto, params)
        const blob = new Blob([adjunto], {
          type: 'application/pdf'
        })
        const url = URL.createObjectURL(blob)
        this.url = url
        // window.open(url)
      } catch (error) {
        this.doFeedback('Error al descargar el adjunto')
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) { return str }
      const subString = str.substr(0, n - 1) // the original check
      return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + '...'
    },
    showActionModal: function (action) {
      this.selectedAction = action
      if (action.IdAccion === 3) { // Accion de Borrar utiliza dialogo
        this.showModalDelete = !this.showModalDelete
      } else if (this.selectedAction.IdAccion === 4) { // tramitar
        this.showModalTramitar = true 
      } else if (action.IdAccion === 11) { // Accion de Archivar sin descargar utiliza dialogo
        this.showModalArchivar = !this.showModalArchivar
      } else if (action.IdAccion === 1 || action.IdAccion === 12) { // Accion de Descargar utiliza dialogo
        this.showModal = !this.showModal
      } else if (this.selectedAction.IdAccion === 9 || this.selectedAction.IdAccion === 19) { // Enviar aviso email a elección
        this.newWhiteMailToggleDialog()
      } else if (this.selectedAction.IdAccion === 16 || this.selectedAction.IdAccion === 20) { // Enviar aviso email vinculados
        if (this.hasModuleCustomMails) {
          this.toggleTextoCorreo()
        } else {
          this.sendMailAVinculadosHandler()
        }
      } else if (this.selectedAction.IdAccion === 17) { // Rechazar (Módulo de aprobación)
        this.toggleMotivoRechazo()
      } else if (this.selectedAction.IdAccion === 102) { // Reasignar propietario a grupo
        this.toggleDialogReasign()
      } else if (this.selectedAction.IdAccion === 103) { // Vincular grupo
        this.toggleDialogVincGroup()
      } else if (this.selectedAction.IdAccion === 500) { // Reasignar usuario responsable
        this.toggleDialogUserResponsable()
      } else if (this.selectedAction.IdAccion === 501) { // Desvincular usuario responsable
        this.unlinkUserResponsable()
      } else if (this.selectedAction.IdAccion === 21) { // aplicar reglas manualmente
        this.showModalApplyRules = true 
      } else if (this.selectedAction.IdAccion === 700) { // nueva diligencia
        this.goToNewProdecing()
      } else if (this.selectedAction.IdAccion === 600) { // Aceptar sugerencias IA
        this.toggleAcceptSuggestIA()
      } else if (this.selectedAction.IdAccion === 601) { // Rechazar sugerencias IA
        this.toggleCancelSuggestIA()
      } else if (this.selectedAction.IdAccion === 22) { // Enviar sugerencias IA
        this.enviaraiaHandler()
      } else if (this.selectedAction.IdAccion === 603) { // Reintentar envío sugerencias IA
        this.reintentarenviosiaHandler()
      } else {
        this.submitAction()
      }
    },
    toggleAcceptSuggestIA () {
      this.showModalAcceptSuggestIA = !this.showModalAcceptSuggestIA
    },
    toggleCancelSuggestIA () {
      this.showModalCancelSuggestIA = !this.showModalCancelSuggestIA
    },
    goToNewProdecing () {
      this.$router.push({
        name: 'procedings/details',
        params: { 
          id: -1,
          idNEO: this.notificationId,
          TicketID: this.form.TicketID,
          NumDiligencia: this.form.Metadatos.filter(x => x.Campo === 'AEAT_NUMERO_DILIGENCIA')[0]?.Valor,
          NIFPagadora: this.form.CIFTitular,
          NIFDeudor: this.form.Metadatos.filter(x => x.Campo === 'AEAT_TITULAR_PROCEDIMIENTO_NIF')[0]?.Valor
        } 
      })
    },
    goToDiligencias () {
      const data = { filters: [{ type: 'ticketid', data: this.form.TicketID }] }
      this.pushRouteNameAux(data, 'procedings')
    },
    pushRouteNameAux (data, name) {
      this.$router.push(
        {
          name: name, 
          params: { data: data }, 
          query: { _r: uuidv4() } 
        })
    },
    toggleDialogReasign () {
      if (this.showModalLinkGroupsReasig) return
      this.groupReasignSelected = null
      this.mantenerGrupo = false
      this.showModalLinkGroupsReasig = !this.showModalLinkGroupsReasig
    },
    applyLinkHandler: async function () {
      const notificationId = this.notificationId
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idNEOs: [notificationId] }
        payload.idGrupos = this.listaGroupsSelected
        const response = await linkNEOGroupsMultiple(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
          await this.downloadNotificationData(notificationId)
        }
        this.listaGroupsSelected = []
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogVincGroup () {
      if (this.showModalLinkGroups && this.isLoadingSelect) return
      this.listaGroupsSelected = []
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.listaGroups.forEach(element => {
        setTimeout(() => {
          this.listaGroupsSelected.push(element.id)
          if (this.listaGroupsSelected.length === this.listaGroups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.listaGroupsSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaGroupsSelected.pop()
          if (this.listaGroupsSelected.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    applyLinkReasignHandler: async function () {
      this.showModalLinkGroupsReasig = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupo: this.groupReasignSelected, idNotificaciones: [], mantenerGrupo: this.mantenerGrupo }
        payload.idNotificaciones.push(this.notificationId)
        const response = await linkNEOsGroupReasign(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.groupReasignSelected = null
          this.mantenerGrupo = false
          this.$router.push({ name: this.header.url })
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyUserResponsableReasignHandler: async function () {
      if (!this.userResponsableSelected) {
        this.doFeedback('Debe seleccionar un usuario responsable')
        return
      }
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idUsuario: this.userResponsableSelected, idNotificaciones: [this.notificationId] }
        const response = await asignarusuarioresponsableneos(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          await this.downloadNotificationData(this.notificationId)
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.showUserResponsable = false
        this.userResponsableSelected = null
        this.$store.commit('setIsLoading', false)
      }
    },
    unlinkUserResponsableHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idNotificaciones: [this.notificationId] }
        const response = await asignarusuarioresponsableneos(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          await this.downloadNotificationData(this.notificationId)
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    loadGroupsSimple: async function (val, withoutReparto = false) {
      try {
        if (val === true) {
          const data = await getGroupsSimple({ idNEO: this.notificationId })
          if (data.blnError === true) {
            this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
          } else {
            data.Respuesta.forEach(row => {
              if (withoutReparto) {
                if (row.idTipo === 1 || row.idTipo === 2) {
                  this.listaGroups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo, idTipo: row.idTipo })
                }
              } else {
                this.listaGroups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo, idTipo: row.idTipo })
              }
            })
          }
        } else {
          this.listaGroups = []
        }
      } catch (error) {
        this.doFeedback()
      } 
    },
    toggleMotivoRechazo () {
      this.showModalRechazo = !this.showModalRechazo
    },
    rechazoDialogHandler: async function (MotivoRechazo) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          MotivoRechazo: MotivoRechazo,
          idNotificaciones: [this.notificationId],
        }
        const response = await sendRejectNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.showModalRechazo = false
          this.$router.push({ name: this.header.url })
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    sendMailAVinculadosHandler: async function (form) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          idNotificaciones: [this.notificationId], 
          TextoCorreo: form?.TextoCorreo,
          AsuntoCorreo: form?.AsuntoCorreo,
        }
        const response = await sendMailNEOVinculados(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false) 
        if (this.hasModuleCustomMails) {
          this.toggleTextoCorreo()
        }
      }
    },
    submitAction: async function () {
      const idNEOs = [{ IDNEO: this.notificationId, Estado: this.notificationType }]
      const IdAccion = this.selectedAction.IdAccion
      try {
        this.$store.commit('setIsLoading', true)
        const response = await updateNotificationStatus(IdAccion, { NEOs: idNEOs, IdAccion })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.$router.push({ name: this.header.url })
        }
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyRulesManualHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const notificationId = this.notificationId
        const payload = { idsNEOs: [notificationId] }
        const response = await aplicarreglasneos(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          await this.downloadNotificationData(notificationId)
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyRulesManualEmailHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const notificationId = this.notificationId
        const params = { idNEO: notificationId }
        const response = await aplicarreglasneosemail(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          await this.downloadNotificationData(notificationId)
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    formatNombreOrgProvince (element) {
      return element.CodigoOrganismo + ' - ' + 
        element.NombreOrganismo + ' / ' + 
        element.CodigoProvincia + ' - ' + 
        element.NombreProvincia
    },
    remoteOrganismosProv: async function (query) {
      this.valuesOrganismosProv = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismoProvinciaByNEO({ filtro: query, idCliente: this.form.idCliente })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.respuesta !== undefined && organismos.respuesta.length > 0) {
            let organismosMatch = []
            if (organismos.respuesta.length > 200) {
              organismosMatch = organismos.respuesta.filter(x => 
                x.CodigoProvincia.toUpperCase() === query.toUpperCase() || 
                x.NombreProvincia.toUpperCase() === query.toUpperCase() || 
                x.CodigoOrganismo.toUpperCase() === query.toUpperCase() || 
                x.NombreOrganismo.toUpperCase() === query.toUpperCase()
              )
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.respuesta
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismosProv.push(
                { 
                  id: element.idOrganismoProvincia, 
                  label: this.formatNombreOrgProvince(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    },
    
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.idOrganismo, 
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    }
  }

}
</script>

<style scoped>
.full-screen-pdf{
  position:fixed;
  top:0;
  left:0;
  z-index:99999;
}
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="scss" >
.hideHeader {
  display: none
}
.showHeader {
  display: block
}
.hideHScroll {
  overflow-x: hidden;
}
</style>
